<div class="wrapper ">
    <app-sidebar></app-sidebar>
  
    <div class="main-panel">
      <app-navbar></app-navbar>
      <div class="content">
        <router-outlet></router-outlet>
      </div>
      <app-footer></app-footer>
    </div>
  </div>
  
